<template>
    <div class="content-container-white">
        <div class="container">
            <ModuleHeader :title="$route.params.slug">
            </ModuleHeader>
        </div>

        <div class="loading" v-if="!project && !error">

        </div>

        <div v-if="error" class="error">
            <div class="mb-4">{{ error }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="saveError" class="error">
            <div class="mb-4">{{ saveError }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="project && !saveError" class="container">


            <div class="row">
                <div class="col"><h2 class="form-object-title">{{project.name}}</h2></div>
            </div>

            <div class="row mt-4">
                <div class="col-md-2"><span class="project-data-title">Ersteller:</span></div><div class="col-md-4"><span class="project-data-value">{{project.user.email}}</span></div>
                <div class="col-md-2"><span class="project-data-title">Erstelldatum:</span></div><div class="col-md-4"><span class="project-data-value">{{project.createDate | moment("DD.MM.YYYY HH:mm")}}</span></div>
            </div>

            <div class="row mt-1">
                <div class="col-md-2"><span class="project-data-title">Type:</span></div><div class="col-md-4"><span class="project-data-value">{{project.type | projectType}}</span></div>
                <div class="col-md-2"><span class="project-data-title">Kunde:</span></div><div class="col-md-4"><span class="project-data-value">{{project.customer_name}}</span></div>
            </div>

            <div class="row mt-3">
                <div v-show="project.type === 'timeandmaterial' || project.type === 'hoursamount'" class="col-md-2"><span class="project-data-title">Stundenpreis:</span></div><div v-show="project.type === 'timeandmaterial' || project.type === 'hoursamount'" class="col-md-4"><span class="project-data-value">{{project.hourrate}} €</span></div>

                <div v-show="project.type === 'timeandmaterial' || project.type === 'hoursamount'" class="col-md-2"><span class="project-data-title">Verrechnete Stunden:</span></div>
                <div v-show="project.type === 'timeandmaterial' || project.type === 'hoursamount'" class="col-md-4"><span class="project-data-value">{{billedHours}}</span></div>

                <div v-show="project.type === 'timeandmaterial' || project.type === 'hoursamount'" class="col-md-2"><span class="project-data-title">Offene Stunden:</span></div>
                <div v-show="project.type === 'timeandmaterial' || project.type === 'hoursamount'" class="col-md-4"><span class="project-data-value"><b-badge variant="danger">{{notBilledHours}}</b-badge></span></div>

                <div v-show="project.type === 'hoursamount'" class="col-md-2">
                    <span class="project-data-title">Stundenkontingent:</span>
                </div>
                <div v-show="project.type === 'hoursamount'" class="col-md-4">
                    <span class="project-data-value">{{project.houramount}}</span>
                </div>

                <div v-show="project.type === 'hoursamount'" class="col-md-2">
                    <span class="project-data-title">Verbraucht:</span>
                </div>
                <div v-show="project.type === 'hoursamount'" class="col-md-4">
                    <span class="project-data-value">{{usedHours}}</span>
                </div>

                <div v-show="project.type === 'hoursamount'" class="col-md-2">
                    <span class="project-data-title">Verfügbar:</span>
                </div>
                <div v-show="project.type === 'hoursamount'" class="col-md-4">
                    <b-badge :variant="(project.houramount - usedHours) > 0 ? 'success' : 'danger'">{{project.houramount - usedHours}}</b-badge>
                </div>

                <div v-show="project.type === 'fixedprice'" class="col-md-2"><span class="project-data-title">Pauschale:</span></div><div v-show="project.type === 'fixedprice'" class="col-md-4"><span class="project-data-value">{{project.fixedprice}} €</span></div>
                <div v-show="project.type === 'fixedprice'" class="col-md-2"><span class="project-data-title">Verrechnet:</span></div><div v-show="project.type === 'fixedprice'" class="col-md-4"><span class="project-data-value"><b-badge variant="success">{{project.billedamount}}</b-badge> €</span></div>
                <div v-show="project.type === 'fixedprice'" class="col-md-2"><span class="project-data-title">Offen:</span></div><div v-show="project.type === 'fixedprice'" class="col-md-4"><span class="project-data-value"><b-badge variant="warning">{{project.fixedprice - project.billedamount}}</b-badge> €</span></div>
            </div>

            <div class="row mt-5">

                <div class="col-12"><h6>Beschreibung</h6></div>
                <div class="col-12">
                    <long-text-editor :text="project.description" @update="updateProjectDescription" class="project-data-title"></long-text-editor>
                </div>
            </div>

            <booked-hours-editor title="Verbrauchte Stunden" :project="project" class="mt-5" v-if="project.type === 'hoursamount'">

                <div class="col-12">
                    <b-progress class="mt-3" :max="project.houramount" show-value style="width: 50%">
                        <b-progress-bar :value="usedHours" variant="danger"></b-progress-bar>
                        <b-progress-bar :value="project.houramount - usedHours" variant="success"></b-progress-bar>
                    </b-progress>
                </div>
            </booked-hours-editor>

            <booked-hours-editor title="Gebuchte Stunden" :project="project" class="mt-5" v-if="project.type === 'timeandmaterial'">

            </booked-hours-editor>

        </div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import firestore from "firedb/init";
    import LongTextEditor from 'components/util/LongTextEditor';
    import JiraTaskViewer from 'components/project/JiraTaskViewer';
    import BookedHoursEditor from 'components/project/hourseditor/BookedHoursEditor';

    export default {
        name: "ProjectEdit",

        components: {ModuleHeader, LongTextEditor, JiraTaskViewer, BookedHoursEditor},

        data: function() {
            return {
                project: null,
                error: null,
                saveError: null
            }
        },
        created() {

            if (this.$route.params.slug) {

                //const ref = firestore.collection('project').doc(this.$route.params.id);
                const ref = firestore.collection('project').where('slug', '==', this.$route.params.slug);

                ref.get().then(snapshot => {

                    if (snapshot.empty) {
                        this.error = "Projekt konte nicht geladen werden";
                    } else {
                        snapshot.forEach(doc => {

                            this.project = doc.data();
                            this.project.id = doc.id;
                        });
                    }
                })
                    .catch(e => {
                        console.log(e);
                        this.error = "Projekt konte nicht geladen werden";
                    });
            }
        },
        methods: {

            updateProject() {

                firestore.collection('project').doc(this.project.id).set(this.project);


                /*
                set(
                    data
                )
                    .then(result => {

                    }).catch(e => {
                        console.log('LEIDER NEIN');
                    console.error(e);
                    this.saveError = "Update konnte nicht ausgeführt werden."
                });
                */
            },

            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },

            updateProjectDescription(text) {

                if (text && text.trim() !== '') {
                    this.project.description = text;
                    this.updateProject();
                }
            },
        },

        computed: {

            usedHours: function() {

                return this.project.usedHours.map(data => {
                    return data.amount;
                }).reduce((a, b) => {
                    return +a + +b;
                }, 0);
            },

            billedHours() {
                return this.project.usedHours.filter(data => data.billId)
                    .map(data => {
                        return data.amount;
                    }).reduce((a, b) => {
                        return +a + +b;
                    }, 0);
            },

            notBilledHours() {
                return this.project.usedHours.filter(data => !data.billId)
                    .map(data => {
                        return data.amount;
                    }).reduce((a, b) => {
                        return +a + +b;
                    }, 0);
            }
        },

        filters: {
            
            projectType: function(value) {
                
                if (!value) return '';
                
                switch (value) {

                    case 'timeandmaterial' :    return 'Time and Material';
                    case 'fixedprice' :         return 'Pauschale';
                    case 'hoursamount' :        return 'Stundenkontingent';
                    default: return '';
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .buttons {
        margin-top: 2rem;
    }

    .project-data-title {
        color: #5e6c84;
        font-size: 0.9rem;
    }

    .project-data-value {
        font-size: 0.9rem;
    }
</style>